import { render, staticRenderFns } from "./TermEditRelationship.vue?vue&type=template&id=165ca62c&scoped=true"
import script from "./TermEditRelationship.vue?vue&type=script&lang=js"
export * from "./TermEditRelationship.vue?vue&type=script&lang=js"
import style0 from "./TermEditRelationship.vue?vue&type=style&index=0&id=165ca62c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "165ca62c",
  null
  
)

export default component.exports